import styled from 'styled-components'

import { Icon, Text, IconProps } from 'components'

type Props = IconProps & {
  label?: string
  onLinkClick: () => void
}

const IconLink = ({ label, onLinkClick, color = 'blue1', ...props }: Props) => (
  <Container onClick={onLinkClick}>
    {props.icon && <Icon color={color} {...props} />}
    <Text lineHeight="24px" fontSize={16} color="blue1" fontWeight="bold">
      {label}
    </Text>
  </Container>
)

const Container = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
    text-decoration-color: ${({ theme }) => theme.colors.blue1};
  }
`

export default IconLink
